import styled from 'styled-components';


export const Container = styled.div`
  display: flex;

  @media (max-width: 630px) {
    text-align: center;
    flex-direction: column;
  }
`;

export const ContentLeft = styled.div`
 margin-top:30px;
  @media (max-width: 630px) {
    margin-top: 4px;
  }
`;

export const Profile = styled.p`
  font-size: 1.8rem;
  color:#0B1DA5;
  margin-bottom: 15px;
  line-height: 3.2rem;
`;

export const Description = styled.p`
  color: #1a1a1a;
  font-size: 1.8rem;
  line-height: 3.2rem;
  margin: 10px 0px 0px;
`;

export const ContentImg = styled.div`

  @media (max-width: 630px) {
    order: -1;
  }
`;

export const Img = styled.img`
  border: 1px solid #ddd;
  border-radius: 5.0rem;
  padding: 5px;
  width: 30rem;
  margin-left: 30px;

  @media (max-width: 630px) {
    /* display:none; */
    width: 15rem;
    border-radius: 8.0rem;
  }

`;
